// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-navigation-drawer.side-bar-left[data-v-56864155] {\n  top: 145px !important;\n}\n.secondary-light-text[data-v-56864155] {\n  color: var(--v-primary-lighten3);\n}\n", ""]);
// Exports
module.exports = exports;
